import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"
import { getSrc } from "gatsby-plugin-image"
import KarlaWoff2 from '@fontsource-variable/karla/files/karla-latin-wght-normal.woff2?url';

import Favicon from './SRA-Favicon.png'

const SEO = ({ title, description, image, article, noIndex }) => {
  const { pathname } = useLocation()
  const data = useStaticQuery(graphql`
    query SEO {
      site {
        siteMetadata {
          defaultTitle: title
          titleTemplate
          defaultDescription: description
          siteUrl: siteUrl
        }
      }
      defaultImage: file(relativePath: { eq: "backgrounds/og-sra-new.png" }) {
        childImageSharp {
          gatsbyImageData(
            width: 1200
          )
        }
      }
      prismicGeneralSettings {
        data {
          site_title
          site_description
        }
      }
    }
  `)

  const {
    defaultTitle,
    titleTemplate,
    defaultDescription,
    siteUrl,
  } = data.site.siteMetadata

  const defaultImage = getSrc(data.defaultImage)
  const doc = data.prismicGeneralSettings

  const SEO = {
    title: title || `${doc.data.site_title || defaultTitle}`,
    description: description ? description : "",
    image: image || `${image || defaultImage}`,
    url: `${siteUrl}${pathname}`,
  }

  return (
    <Helmet title={SEO.title} titleTemplate={titleTemplate}>
      <meta name="description" content={SEO.description} />
      <meta name="image" content={SEO.image} />

      {noIndex ? <meta name="robots" content="noindex" /> : null}

      <link rel="icon" type="image/png" href={Favicon} />

      {SEO.url && <meta property="og:url" content={SEO.url} />}

      {(article ? true : null) && <meta property="og:type" content="article" />}

      {SEO.title && <meta property="og:title" content={SEO.title} />}

      {SEO.description && (
        <meta property="og:description" content={SEO.description} />
      )}

      {SEO.image && <meta property="og:image" content={SEO.image} />}

      <meta name="twitter:card" content="summary_large_image" />

      {SEO.title && <meta name="twitter:title" content={SEO.title} />}

      {SEO.description && (
        <meta name="twitter:description" content={SEO.description} />
      )}

      {SEO.image && <meta name="twitter:image" content={SEO.image} />}

      <link
        rel="preload"
        href="https://www.831b.com/fonts/karla-latin-wght-normal.woff2"
        as="font"
        type="font/woff2"
        crossorigin="anonymous"
      />

      <link rel="preconnect" href="https://www.831b.com" />
      <link rel="preconnect" href="https://sra-website.prismic.io" crossorigin />
      <link rel="preconnect" href="https://www.googletagmanager.com" crossorigin />
      <link rel="preconnect" href="https://fast.wistia.com" crossorigin />
      <link rel="preconnect" href="https://acsbapp.com" crossorigin />
      <link rel="preconnect" href="https://www.clickcease.com" crossorigin />
      <link rel="preconnect" href="https://w.chatlio.com" crossorigin />
      <link rel="preconnect" href="https://script.hotjar.com" crossorigin />

      <link rel="preload" href="https://fast.wistia.com/assets/external/E-v1.js" as="script" />
      <link rel="preload" href="https://fast.wistia.com/assets/external/playPauseLoadingControl.js" as="script" />
      <link rel="preload" href="https://fast.wistia.com/assets/external/captions.js" as="script" />

      <link rel="preload" href="https://acsbapp.com/apps/app/dist/js/app.js" as="script" />

      <link rel="preload" href="https://w.chatlio.com/v5/w.chatlio-widget.js" as="script" />
      <link rel="preload" href="https://w.chatlio.com/v5/vendor/chatlio.min.7ab10269.js" as="script" />

      <link rel="preload" href="https://www.831b.com/app-904f5ceba658adc905eb.js" as="script" />
      <link rel="preload" href="https://www.831b.com/app-ef364579647e3bcf3981.js" as="script" />

      <link rel="preload" href="https://js.hubspot.com/web-interactives-embed.js" as="script" />
      <link rel="preload" href="https://js.hs-banner.com/v2/23182726/banner.js" as="script" />

      <link rel="preload" href="https://static.cdn.prismic.io/prismic.js?repo=sra-website&new=true" as="script" />
      <link rel="preload" href="https://sra-website.prismic.io/prismic-toolbar/4.1.1/iframe.html" as="iframe" crossorigin />

      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "url": "https://www.831b.com",
            "name": "SRA 831(b) ADMIN",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Eagle",
              "addressRegion": "ID",
              "postalCode": "83616",
              "streetAddress": "776 E Riverside Dr, Suite 200"
            },
            "email": "info@831b.com",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "208-424-2249",
              "contactType": "Customer Support"
            }
          }
        `}
      </script>

      <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />

      <script type='text/javascript' data-cfasync="false" id='vwoCode'>
        {`
          window._vwo_code || (function() {
            var account_id=811631,
            version=2.0,
            settings_tolerance=2000,
            hide_element='body',
            hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
            /* DO NOT EDIT BELOW THIS LINE */
            f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();
        `}
      </script>

      <script src="https://js.chatlio.com/widget.js" async></script>      
    </Helmet>
  )
}

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  article: PropTypes.bool,
  noIndex: PropTypes.bool,
}

SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  article: false,
  noIndex: false,
}